// Specific locale references
export type Locale = 'en'; // | 'ja';
const fallbackLocale: Locale = 'en';

export const localeRuleset = {
  fallbackLocale,
};
